import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../_services';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            // authorised so return true
            // console.log("enrtamos en helper current user ")
            return true;
        }

        const currentRole = this.authenticationService.currentRoleValue;
        if (currentRole) {
            // console.log("enrtamos en helper current role ")
            // authorised so return true
            return currentRole;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url,  amazon_callback_uri: route.queryParams['amazon_callback_uri'], amazon_state: route.queryParams['amazon_state'], selling_partner_id: route.queryParams['selling_partner_id']}});
        return false;
    }
}